import { SET_ID } from '../actions/actionTypes';

const initialState = {
  id: null
};

export const AutorizacaoState = (state = initialState, action) => {
  switch (action.type) {
    case SET_ID:
      return { ...state, id: action.payload };
    default:
      return state;
  }
};
